import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function DemandAnalysis({ summaryReports }) {
    var chart = {
        type: 'column'
    };
    var title = {
        text: "Demand Variance",
        align: "left",
        style: {
            fontSize: "14px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
       // format: '<strong>{key}</strong><br/>{series.name}: <strong>{y}</strong><br/>',
        formatter: function () {
            var tooltipText = `<strong>${this.x}</strong>`+ '<br/>';
            if (this.series.name === 'Forecasted Demand') {
              tooltipText += '<span style="color: #BB4A28;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
            } else if (this.series.name === 'Actual Demand') {
              tooltipText += '<span style="color: #005A70;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
            }
            return tooltipText;
          },
        borderWidth: 1,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '14px',
        }
    };
    var legend = {
        enabled: true,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        column: {

            dataLabels: {
                enabled: false,
                style: {
                    textOutline: "none",
                },
            },
        },
        series:{
            events: {
                legendItemClick: function() {
                    return false;
                }
              }
        }
    };
    var series = [
        {
            name: "Forecasted Demand",
            data: [summaryReports?.DemandAnalysis?.forecastedDemands?.REGULAR,summaryReports?.DemandAnalysis?.forecastedDemands?.MIDGRADE,summaryReports?.DemandAnalysis?.forecastedDemands?.PREMIUM],
            color: "#BB4A28",

        },
        {
            name: "Actual Demand",
            data: [summaryReports?.DemandAnalysis?.actualDemands?.REGULAR,summaryReports?.DemandAnalysis?.actualDemands?.MIDGRADE,summaryReports?.DemandAnalysis?.actualDemands?.PREMIUM],
            color: "#005A70",

        }
    ];
    var xAxis = {
        categories: ['Regular', 'Midgrade', 'Premium'],
        title: {
            text: "Gasoline Type",
        },
        lineColor: '#EFEFEC'
    }
    var yAxis = {
        allowDecimals: false,
        crosshair: true,
        min: 0,
        title: {
            text: 'Demand'
        }
    }
    var accessibility = {
        enabled: true,
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.xAxis = xAxis;
    json.yAxis = yAxis;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        Highcharts.chart("DemandAnalysis", json);
        //console.log(json);
    };
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div
            id="DemandAnalysis"
            style={{ height: "340px" }}
            title={title.text}
            aria-label="Cost Analysis Graph"
            className="costAnalysis"
        ></div>
    );
}
